enum Feature {
  MAP = "map",
  DISALLOW_COLOR = "disallowColor",
}

export default Feature;
